/**
 * これはCSVImportUIのためにsumyca-manager-frontで作成されたものであり、
 * matsuri-uiのコンポーネントとして使用できません。
 */
export const UploadCsvButton = ({
  onChange,
}: {
  onChange: (file: File) => void;
}) => {
  return (
    <input
      type="file"
      accept=".csv"
      onChange={(event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        onChange(file);
      }}
    />
  );
};
